/**
 * Données Phase 1 — jeu initial minimal BT-046 + leadership document BlackDragon2026.
 * Emplacements dojo / responsables : placeholders [DÉMO] à confirmer.
 * Noms réels limités aux personnes explicitement fournies (Gilles, Marcel, Natalie).
 */

import {
  buildSeedDojos,
  buildSeedResponsibles,
  buildSeedStudents,
  BLACK_DRAGON_LEADERSHIP_INSTRUCTORS,
} from "./phase1InitialSeed046.js";

/** @type {import('./types.js').Dojo[]} */
export const demoDojos = buildSeedDojos();

/** @type {import('./types.js').Instructeur[]} */
export const demoInstructeurs = [
  ...BLACK_DRAGON_LEADERSHIP_INSTRUCTORS,
  ...buildSeedResponsibles(),
  {
    id: "demo-sensei-placeholder",
    nom: "[DÉMO] Sensei — emplacement réservé",
    titre: "Sensei (à assigner)",
    dojo_id: "demo-dojo-01",
    courriel: "",
    telephone: "",
    statut: "a_confirmer",
    demo: true,
  },
];

/** @type {import('./types.js').Etudiant[]} */
export const demoEtudiants = buildSeedStudents();

/** @type {import('./types.js').DocumentItem[]} */
export const demoDocuments = [
  {
    id: "doc-presentation",
    titre: "Présentation Shotokan AAMC — Black Dragon",
    categorie: "Présentation",
    visibilite: "public",
    reference: "accueil-portail",
    statut: "actif",
    demo: true,
  },
  {
    id: "doc-protocole-grades",
    titre: "Protocole grades et titres — Black Dragon Canadien",
    categorie: "Protocole",
    visibilite: "a_valider",
    reference: "gilles/ProtocoleduBlackDragonCanadien.doc",
    statut: "a_confirmer",
    demo: false,
  },
  {
    id: "doc-symbolisme",
    titre: "Symbolisme Black Dragon Fraternity",
    categorie: "Organisation",
    visibilite: "a_valider",
    reference: "gilles/The Black Dragon Fraternity Rai Finch.docx",
    statut: "a_confirmer",
    demo: false,
  },
  {
    id: "doc-interne-admin",
    titre: "[DÉMO] Document interne admin",
    categorie: "Interne",
    visibilite: "admin",
    reference: "admin/interne-demo",
    statut: "actif",
    demo: true,
  },
  {
    id: "doc-membres-protocole",
    titre: "Référentiel ceintures kyu/dan (extrait)",
    categorie: "Protocole",
    visibilite: "membres",
    reference: "protocoles/ceintures-extrait",
    statut: "a_confirmer",
    demo: true,
  },
];

export const PROTOCOLE_SECTIONS = [
  {
    id: "titres",
    titre: "Titres martiaux (aperçu)",
    contenu:
      "Sensei, Renshi, Shihan, Kyoshi, Hanshi — définitions selon le protocole Black Dragon Canadien. Publication complète soumise à validation Hanshi.",
    visibilite: "a_valider",
  },
  {
    id: "ceintures",
    titre: "Grades ceinture (kyu / dan)",
    contenu:
      "Blanche, jaune, orange, verte, bleue, brune, noire — progression par examens supervisés. Détail officiel à importer après validation.",
    visibilite: "membres",
  },
  {
    id: "public",
    titre: "Présentation publique",
    contenu:
      "Le karaté Shotokan AAMC / Black Dragon regroupe plusieurs dojos sous la direction du Hanshi. Phase 1 : portail d'information et d'organisation.",
    visibilite: "public",
  },
];
